import { MutateButton, SubmitButton } from "@imago/api-client-for-react"
import { useGAHTConsented, useMHTConsent, useFHTConsent, useFakeFHTConsent, FormDialog } from "../../FormDialog.tsx"
import { ImagoCare } from '../../Care.tsx'
export { useGAHTConsented as useConsented }

function _Consent() {
	const fhtConsent = useFHTConsent()
	const mhtConsent = useMHTConsent()

	return <>
		<form>
			<p>The informed consent model of care respects your fundamental human right to self-determination and bodily autonomy.</p>
			<p>To start the therapy - fill out our consent form.</p>
			<p><strong>We'll charge you for the Imago Care:</strong></p>
			<ImagoCare preview={true}/>
			<div className="row">
				<SubmitButton mutation={fhtConsent} vars={data => {}}>Feminizing HT consent form</SubmitButton>
				<SubmitButton mutation={mhtConsent} vars={data => {}}>Masculinizing HT consent form</SubmitButton>
			</div>
			<p>You can stop the therapy at any point - but if you come back, we'll charge you for the time it was paused.</p>
		</form>
		<FormDialog mutation={fhtConsent}/>
		<FormDialog mutation={mhtConsent}/>
	</>
}

export function Consent() {
	const done = useGAHTConsented()
	const fakeFHTConsent = useFakeFHTConsent()

	return <section data-done={done ? true : undefined}>
		<hgroup>
			<h2>Give us your consent</h2>
			{!done ?
				<MutateButton className="secondary" mutation={fakeFHTConsent}>TEST: Skip</MutateButton>
			: <></>}
		</hgroup>
		{!done ? <_Consent/> : <></>}
	</section>
}
